module.exports = __webpack_public_path__ + "static/media/secietypic03@3x.c1d0804d.png";